var React = require('react');

function ThumbsUpBgInline (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"264.681","cy":"265.459","r":"262.5","fill":"#2E7943","stroke":"#2E7943","strokeWidth":"5"}));
}

ThumbsUpBgInline.defaultProps = {"width":"530","height":"531","viewBox":"0 0 530 531","fill":"none"};

module.exports = ThumbsUpBgInline;

ThumbsUpBgInline.default = ThumbsUpBgInline;
